import log from '../../utils/logger';

import { setDomainName } from '../../utils/utils';

const services = {
  getPageData: 'https://s4-dev.waters.com/bin/waters/content',

  getPageDataPath: 'nextgen/{localeCountry}/{localeLanguage}',

  getCountryStatus: 'https://s4-dev.waters.com/bin/waters/content',

  getCountryStatusPath: 'nextgen/{localeCountry}',

  shoppingCart:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}',

  orderSummaryData:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/coupons',

  addToCart:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/items',

  removeCart:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}',

  updateCart:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/items/{entry}',

  removeCartItem:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/items/{entry}',

  soldToDetails: 'https://s4-dev-services.waters.com/api/waters/user/v2/retrievesoldto',

  userDetails: 'https://s4-dev-services.waters.com/api/waters/user/v2/details',

  signOut: 'https://s4-dev-services.waters.com/api/waters/user/v2/logout',

  partnerInfo:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-user-exp-api-v2/api/users/{userType}',

  country: 'https://s4-dev-services.waters.com/api/waters/country/v3/{code}',

  creditCards:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-user-exp-api-v2/api/users/{userType}/credit-cards',

  requestQuote:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-quote-exp-api-v2/api/{localeCountry}/{localeLanguage}/quote',

  addAddress: 'https://s4-dev-services.waters.com/api/waters/user/v1/{userType}/addresses',

  bulkUploadAddToCart:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/entries',

  placeOrder:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-order-exp-api-v2/api/{localeCountry}/{localeLanguage}/orders',

  addCreditCard:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-user-exp-api-v2/api/users/{userType}/credit-cards',
  createSetupIntentId: 'https://s4-dev-services.waters.com/api/payment/v1/setup_intents',

  getPromoCodeDetails: 'https://s4-dev-services.waters.com/api/waters/coupon/v1/{promoCode}',

  setSwitchAccount: 'https://s4-dev-services.waters.com/api/waters/user/v2/switchaccount/{soldTo}',

  shoppingCartProxy:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}',

  searchBar: 'https://s4-dev-services.waters.com/api/waters/search/v1/autocomplete',

  quoteDetails:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-quote-exp-api-v2/api/quote/{quoteId}',

  quoteToOrder:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-order-exp-api-v2/api/{localeCountry}/{localeLanguage}/quote/order',

  systemNotification:
    'https://s4-dev-services.waters.com/bin/waters/notifications.{localeLanguage}.json',

  shareCart:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-cart-exp-api-v2/api/{localeCountry}/{localeLanguage}/users/{userType}/cart/share',

  signIn: 'https://s4-dev-services.waters.com/api/waters/user/v2/login',

  userAuthentication: 'https://s4-dev-services.waters.com/api/waters/user/v2/isAuthenticated',
  retriveDPAToken: 'https://s4-dev-services.waters.com/api/payment/v1/retrieve_dpatoken',

  shareOrder:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-order-exp-api-v2/api/{localeCountry}/{localeLanguage}/order/share',

  pricingUrl:
    'https://api-sbox.waters.com/p2/ext-uat-s4-waters-product-exp-api-v2/api/products/prices',

  announcementNotification:
    'https://s4-dev.waters.com/api/assets/waters/{localeLanguage}/content-fragments/notifications.json',
  createCustomerOnStripe: 'https://s4-dev-services.waters.com/api/payment/v1/customers',
};

try {
  if (window.apiEndpoints) {
    // if document referer exist

    // prepend in page data and country api

    const { getPageData, getCountryStatus } = window.apiEndpoints;

    window.apiEndpoints.getPageData = setDomainName(getPageData);

    window.apiEndpoints.getCountryStatus = setDomainName(getCountryStatus);

    Object.assign(services, window.apiEndpoints);
  }
} catch (error) {
  const obj = {
    message: 'API endpoints for the env are not available, using defaults',

    error,
  };

  log(obj);
}

export default services;
